import { Party } from "@harlowe/core";
import { Type } from "class-transformer";

export class Plan
{
    constructor
    (
        public effectiveDate: Date,
        public expirationDate: Date,
        public memberId: string,
        public subscriberName: string,
        public dependentCount: number
    )
    {

    }
}

export class Member
{
    constructor
    (
        public gender: number,
        public relationToSubscriber: number,
        public memberId: string,
        person: Party

    )
    {
        this.person = person;
    }

    @Type(() => Party)
    person: Party;
}